// Resolves the API base URL, preferring same-origin when the frontend is
// served from a different host than REACT_APP_BACKEND_URL points to.
//
// Why: Custom domains (e.g. ascendforyou.net) rewrite `/api/*` to the backend
// at the ingress layer, so the frontend can talk to the API without CORS.
// The env-var URL only matters for local dev where the frontend and backend
// live on different ports.
//
// Using same-origin whenever possible eliminates:
//   1. Cross-origin preflight overhead
//   2. CORS spec violations (wildcard + credentials)
//   3. Deploy-time env-var rewrites that point at stale hosts

const envUrl = process.env.REACT_APP_BACKEND_URL || '';

const resolveBase = () => {
  if (typeof window === 'undefined') return envUrl; // SSR safety
  try {
    // If env var is missing or its origin matches ours, use the env value.
    if (!envUrl) return window.location.origin;
    const envOrigin = new URL(envUrl).origin;
    if (envOrigin === window.location.origin) return envUrl;
    // Different host (e.g. prod custom domain) → use current origin so
    // the ingress proxies /api/* to the right backend without CORS.
    return window.location.origin;
  } catch {
    return window.location.origin;
  }
};

export const API_BASE = resolveBase();
export const API = `${API_BASE}/api`;
